import { ThemeEvents, CartUpdateEvent } from '@theme/events';

if (!window.customElements.get('shipping-protection')) {
  class ShippingProtection extends HTMLElement {
    constructor() {
      super();
      console.log('constructor')
    }

    connectedCallback() {
      console.log('connected callback')
      if(window.shipping_protection_running == true){
        return;
      }else{
        window.shipping_protection_running = true;
      }
      

      // Default to enabled if no session value
      if (sessionStorage.getItem('noprotection') === null || sessionStorage.getItem('noprotection') == 'false') {
        sessionStorage.setItem('noprotection', 'false');

        const link = this.querySelector('[data-protection-id]');
        if (link) {
          link.classList.add('active');
        }

        // Kick off logic to add protection if needed
        this.handleProtectionLogic();
      }

      this.addEventListeners();
    }

    get variants() {
      try {
        return JSON.parse(this.dataset.variants || '[]');
      } catch {
        return [];
      }
    }

    get cartTotal() {
      return parseInt(this.dataset.cartTotal || '0', 10);
    }

    get currentProtectionId() {
      return this.dataset.currentId;
    }

    get cartItemCount() {
      return parseInt(this.dataset.cartItemCount || '0', 10);
    }

    get bestVariant() {
      return this.variants.find(
        (variant) => parseInt(variant.sku || '0', 10) > this.cartTotal
      );
    }

    async handleProtectionLogic() {
      if (sessionStorage.getItem('noprotection') === 'true'){
        window.shipping_protection_running = false
        return;
      }
      console.log('lets add protection')

      // Finds the best shipping protection variant based on the cart total
      const best = this.bestVariant;
      if (!best){
        window.shipping_protection_running = false
        return;
      }

      const current = this.currentProtectionId;

      if (current && current !== String(best.id)) {
        await this.updateCart({ [current]: 0, [best.id]: 1 });
      } else if (this.cartItemCount === 1 && current) {
        await this.updateCart({ [current]: 0 });
      } else if (this.cartItemCount > 0 && !current) {
        await this.updateCart({ [best.id]: 1 });
      }
      window.shipping_protection_running = false;
    }

    async updateCart(updates) {
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => el instanceof HTMLElement ? el.dataset.sectionId : null)
        .filter(Boolean);

      const payload = {
        updates, // { variantId: qty, ... }
        sections: sectionIds,
      };

      try {
        const resp = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify(payload),
        })
        const data = await resp.json();
        const event = new CartUpdateEvent({ data, shippingProtection: true });
        document.dispatchEvent(event);
      } catch (err) {
        console.error('Cart update error:', err)
      }finally{
        window.shipping_protection_running = false
      }
    }

    addEventListeners() {
      const link = this.querySelector('[data-protection-id]');
      if (!link) return;

      link.addEventListener('click', (e) => {
        e.preventDefault();

        const variantId = link.dataset.protectionId;
        const currentVariantId = this.currentProtectionId;
        if (!variantId) return;

        const isActive = link.classList.contains('active');
        const disabling = isActive;

        // Toggle `noprotection`
        sessionStorage.setItem('noprotection', disabling ? 'true' : 'false');

        // Toggle class
        link.classList.toggle('active', !disabling);

        // Add or remove the protection product
        if (disabling) {
          this.updateCart({ [currentVariantId]: 0 });
        } else {
          this.updateCart({ [variantId]: 1 });
        }

        // Rerun logic (should early return if `noprotection` now true)
        this.handleProtectionLogic();
      });
    }
  }

  customElements.define('shipping-protection', ShippingProtection);
}